<template>
  <div class="register-container">
    <div class="register-box">
      <h1 class="register-title">🎉</h1>
      <form @submit.prevent="register">
        <div class="input-group">
          <input 
            type="text" 
            v-model="registerName" 
            placeholder="用户名/账号/邮箱" 
            required 
            class="input-field"
          />
        </div>
        <div class="input-group">
          <input 
            type="password" 
            v-model="registerPassword" 
            placeholder="密码" 
            required 
            class="input-field"
          />
        </div>
        <!-- 注册按钮 -->
        <div class="button-group">
          <button type="submit" class="register-btn">注册</button>
        </div>
      </form>
      <p class="login-link">
        已经有账号? 
        <router-link to="/login">登录</router-link>
      </p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import apiConfig from "../config/api.js";

export default {
  data() {
    return {
      registerName: "",
      registerPassword: "",
    };
  },
  methods: {
    async register() {
      try {
        await axios.post(`${apiConfig.baseURL}${apiConfig.registerURL}`, {
          name: this.registerName,
          password: this.registerPassword,
        });
        alert("注册成功");
        this.$router.push("/login");
      } catch (error) {
        alert("注册失败");
      }
    }
  }
};
</script>

<style scoped>
.register-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90vh;
  background: #ffffff;
  min-height: 377px;
  padding-top: 54px;
}

.register-box {
  background: rgb(255, 255, 255);
  border-radius: 1.5rem;
  box-shadow: 8px 8px 20px 0 rgba(0, 0, 0, 0.02);
  padding: 20px 30px;
  width: 100%;
  max-width: 377px;
  border: 1.2px solid rgb(239, 239, 239);
  margin: 10px;
}

.register-title {
  text-align: center;
  font-size: 2em;
  margin-bottom: 20px;
}

.input-group {
  margin-bottom: 15px;
}

.input-field {
  width: 90%;
  height: 60px;
  font-size: 1em;
  font-family: 'Arial', sans-serif;
  font-weight: 400;
  color: #333;
  line-height: 60px;
  padding-left: 15px;
  border: 1.2px solid rgb(239, 239, 239);
  border-radius: 1.5rem;
  outline: none;
  transition: border-color 0.3s ease;
}

.input-field::placeholder {
  color: #aaa;
  font-style: italic;
}

.input-field:focus {
  border-color: rgb(254,208,1);
}

/* 新增：使注册按钮居中 */
.button-group {
  display: flex;
  justify-content: center;
}

.register-btn {
  padding-top: .5rem;
  padding-bottom: .5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  background-color: rgb(254,208,1);
  color: white;
  border: 1.2px solid rgb(239, 239, 239);
  border-radius: 9999px;
  font-size: 1em;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

.register-btn:hover {
  background-color: rgb(245, 219, 18);
  border-color: rgb(239, 239, 239);
}

.login-link {
  text-align: center;
  margin-top: 20px;
}

.login-link a {
  color: #03a9f5;
  text-decoration: none;
}

.login-link a:hover {
  text-decoration: underline;
  text-decoration: none;
}

@media (max-width: 768px) {
  .register-container {
    padding-top: 0px;
  }

}
</style>